import axios from 'axios';
import AuthService from './AuthService';

const HttpClient = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API
});

let isRefreshing = false;
let pendingRequests = [];

function processPendingRequests(error, token = null) {
    pendingRequests.forEach(({ resolve, reject }) => {
        if (error) reject(error);
        else resolve(token);
    });
    pendingRequests = [];
}

HttpClient.interceptors.request.use(config => {
    const auth = AuthService.getAuthInfo();
    if (auth && auth.token) config.headers = { 'Authorization': auth.token };
    return config;
}, err => Promise.reject(err));

HttpClient.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        const errorCode = error.response?.data?.error;

        if (errorCode === 'token_expired' && !originalRequest._retry) {
            originalRequest._retry = true;

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    pendingRequests.push({ resolve, reject });
                }).then(token => {
                    originalRequest.headers['Authorization'] = token;
                    return HttpClient(originalRequest);
                });
            }

            isRefreshing = true;

            try {
                const newToken = await AuthService.refreshSession();
                processPendingRequests(null, newToken);
                originalRequest.headers['Authorization'] = newToken;
                return HttpClient(originalRequest);
            } catch (refreshError) {
                processPendingRequests(refreshError);
                AuthService.logout();
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        if (errorCode === 'invalid_token') {
            AuthService.logout();
        }

        return Promise.reject(error);
    }
);

export default HttpClient;
